import { useMemo, useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import useUiuxStore from "src/store/useUiuxStore";

import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_KSK2021_R01 } from "./Content_KSK2021_R01";
import { Info_KSK2021_R01 } from "./Info_KSK2021_R01";
import { DetailTable_KSK2021_R01 } from "./DetailTable_KSK2021_R01";
import { useKSK2021_R01Store } from "./Store_KSK2021_R01";
import { AgGridReact } from "ag-grid-react";
import { KSK2021_R01HeaderDto, KSK2021_R01InspectDto, KSK2021_R01DetailDto } from "./Dto_KSK2021_R01";
import { Modal_KSK2021_R01 } from "./Modal_KSK2021_R01";
import { WorkTimeModal_KSK2021_R01 } from "./WorkTimeModal_KSK2021_R01";


export const Container_KSK2021_R01 = () => {

	const { 
		syncInitialData,
		isDetailMaximized, setIsDetailMaximized,
	} = useKSK2021_R01Store();

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER_HEIGHT = {
		code: 'KSK2021_R01',
		type: 'height',
		storageKey: 'KSK2021_R01-info-split-height',
		min: 5,
		max: 80,
		default: 60
	} as const;

	const gridRef = useRef<AgGridReact<KSK2021_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<KSK2021_R01DetailDto>>(null);
	const inspectGridRef = useRef<AgGridReact<KSK2021_R01InspectDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoAreaRef = useRef<HTMLDivElement>(null);
	const bottomContainerRef = useRef<HTMLDivElement>(null);
	const isHeightResizing = useRef(false);

	const {
		splitValue: heightSplitValue,
		handleMouseDown: handleHeightMouseDown,
	} = useMouseContent({
		resizer: RESIZER_HEIGHT,
		isResizing: isHeightResizing,
		containerRef,
		infoRef: infoAreaRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		defaultKSK2021_R01HeaderRow,
		defaultKSK2021_R01DetailRow,
		defaultKSK2021_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		validateWorkStartEnd,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
	} = Content_KSK2021_R01({
		gridRef,
		detailGridRef,
		inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing: isHeightResizing,
	});

	useMemo(() => { syncInitialData(); }, []);

	const headerDefaultRow = useMemo(() => defaultKSK2021_R01HeaderRow(), [defaultKSK2021_R01HeaderRow]);
	const detailDefaultRow = useMemo(() => defaultKSK2021_R01DetailRow(), [defaultKSK2021_R01DetailRow]);
	const inspectDefaultRow = useMemo(() => defaultKSK2021_R01InspectRow(), [defaultKSK2021_R01InspectRow]);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={handleFetchLotList}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>

		<Modal_KSK2021_R01 
			defaultKSK2021_R01HeaderRow={headerDefaultRow}
			inspectGridRef={inspectGridRef}
			defaultKSK2021_R01InspectRow={inspectDefaultRow}
			handleDeleteClick={handleDeleteClick}
		/>
		<WorkTimeModal_KSK2021_R01 handleWorkTimeClick={handleWorkTimeClick} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0 flex-col" ref={containerRef}>

			{!isDetailMaximized && (
				<>
					<div className="w-full max-w-full flex flex-1 min-h-0 border border-gray-300 overflow-hidden" style={{ height: `${heightSplitValue}%` }}>
						<Info_KSK2021_R01 editable={false}
							defaultKSK2021_R01HeaderRow={headerDefaultRow}
							handleWorkTimeClick={handleWorkTimeClick}
							handleFetchBomProductList={handleFetchBomProductList}
							handleFetchLotList={handleFetchLotList}
							getProductWorkFieldHandlers={getProductWorkFieldHandlers}
							validateWorkStartEnd={validateWorkStartEnd}
						/>
					</div>

					<div
						className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
						onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleHeightMouseDown('UD', e.nativeEvent)}
					/>
				</>
			)}

			<div
				ref={infoAreaRef}
				style={{ height: isDetailMaximized ? '100%' : `${100 - heightSplitValue}%` }}
			>
				<div className="flex h-full gap-[4px]" ref={bottomContainerRef}>
					<DetailTable_KSK2021_R01
						gridRef={detailGridRef}
						defaultKSK2021_R01DetailRow={detailDefaultRow}
						isMaximized={isDetailMaximized}
						onToggleMaximize={() => setIsDetailMaximized(!isDetailMaximized)}
					/>
				</div>
			</div>

		</div>
	</div>
}
